/**
 *
 * @param {Object} obj Object to replace things in
 * @returns Object with {{NULL}} and {{UNDEFINED}} special slugs replaced with null/undefined
 *
 * Will not parse through an Array with an overridden push method (something we have done for some reason)
 */
const replaceNullAndUndefined = (obj) => {
	if (Array.isArray(obj) && obj.push === Array.prototype.push) {
		return obj.map((item) => replaceNullAndUndefined(item));
	} else if (!Array.isArray(obj) && typeof obj === 'object' && obj !== null) {
		return Object.keys(obj).reduce((acc, key) => {
			acc[key] = replaceNullAndUndefined(obj[key]);
			return acc;
		}, {});
	} else if (obj === '{{UNDEFINED}}') {
		return undefined;
	} else if (obj === '{{NULL}}') {
		return null;
	} else {
		return obj;
	}
};

/**
 *
 * @param {Object} payload The payload to be copied and have special slugs replaced
 * @param {Object} eventData The current events eventData
 *
 * Copy the payload object and replace any special slugs: {{xxxxxx}}
 *
 * Special slugs:
 * {{UNDEFINED}} - Preserves undefined in the payload
 * {{REMOVEKEY}} - Removes the key from the payload
 * {{EMPTYSTRING}} - Will set value to empty string if special slug is toggled
 * {{EMPTYOBJECT}} - Will set value to empty object if special slug is toggled
 */
const copyPayload = (payload) => {
	const exceptions = {};

	const payloadStringified = JSON.stringify(payload, (key, value) => {
		if (Array.isArray(value)) {
			if (value.push !== Array.prototype.push) {
				exceptions[key] = value;
			}
		}

		return value;
	});

	const payloadCopy = JSON.parse(payloadStringified, (key, value) => {
		let newValue = value;

		if (value?.includes?.('{{REMOVEKEY}}')) {
			newValue = undefined;
		} else if (value?.includes?.('{{EMPTYSTRING}}')) {
			newValue = '';
		} else if (value?.includes?.('{{EMPTYOBJECT}}')) {
			newValue = {};
		}

		if (exceptions[key]) {
			newValue = exceptions[key];
		}

		return newValue;
	});

	return replaceNullAndUndefined(payloadCopy);
};

export default copyPayload;
